/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../_metronic/_helpers";
import { setNewBookmark } from '../../../redux/features/bookmarks/bookmarksSlice';
import { ordersNavigationActions } from '../../../redux/features/navigation/navigationSlice';
import { pagesLinks } from "../../../utils/PageUtils";
import { Badge } from '@material-ui/core';
import Timer from 'react-compound-timer';
import { dataAPI } from '../../../api/data/dataAPI';
import { GetUser, hasClaim, UOM_EVENT_MONITORING_VALUE, UOM_ROLE, UOM_ROLE_ADMIN, UOM_ROLE_EVENT_MONITORING } from '../../../utils/AuthUtils';

const AsideMenuListContainer = (props) => {
  const location = useLocation();
  //eslint-disable-next-line
  const [layoutProps, setLayoutProps] = useState(props.layoutProps);
  const [linksList, setLinksList] = useState();
  const getMenuItemActive = (url, hasSubmenu) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  // Helper function to check if current path is a booking subpage
  const isBookingSubpage = () => {
    const currentPath = location.pathname;
    return currentPath.startsWith("/listpage/booking") || 
           currentPath.includes("booking-transport-order-execution") ||
           currentPath.includes("booking-reservation-trips");
  };

  function disableNotification() {
    props.setNewBookmark(false);
  }

  function reportLinksBuilder(data) {
    var i = 0;

    if (location.pathname.indexOf("/analytics/custom-views") >= 0) {
      props.setNavigatedMenu("Custom Views");
    }
    else {
      while (i < data.length) {
        if (location.pathname.indexOf("/analytics/views/" + data[i].workspaceId + "/" + data[i].reportId + "/" + data[i].reportPageName) >= 0) {
          props.setNavigatedMenu(data[i].description);
          i = data.length;
        }
        i++;
      }
    }

    const linksList = data.map((x, idx) => (
      <li
        className={`menu-item menu-item-submenu`}
        aria-haspopup="true"
        data-menu-toggle="hover"
        key={"menu-report-" + idx}
      >
        <NavLink className="menu-link menu-toggle" onClick={() => { props.setNavigatedMenu(x.description); }} to={"/analytics/views/" + x.workspaceId + "/" + x.reportId + "/" + x.reportPageName}>
          <span className="menu-text">{x.description}</span>
        </NavLink>
      </li>
    ));

    return linksList;
  }

  useEffect(() => {
    let isMounted = true;
    // setIsFetching(true);
    dataAPI.getListMenuReports(
      res => {
        if (isMounted)
          setLinksList(reportLinksBuilder(res.items));
        //setIsFetching(false);
      });

    return () => {
      isMounted = false;
    };

  }, []);


  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard" onClick={() => { props.setNavigatedMenu("Dashboard"); }}>
            <div className="menu-icon-container">
              <div className="menu-icon menu-svg-dashboard"></div>
              <p>Dashboard</p>
            </div>

            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive(pagesLinks.orderDetailsRootTitle, false)} ${getMenuItemActive(pagesLinks.viewAllTOsExecutionGrid, false)}`}
          aria-haspopup="true"
        >
          <NavLink
            className={"menu-link " + (checkIsActive(location, pagesLinks.orderDetailsRootTitle) ? "active" : "")}
            to={pagesLinks.viewAllTOsExecutionGrid}
            onClick={() => { props.setNavigatedMenu("TO List"); }}>
            <div className="menu-icon-container">
              <div className="menu-icon menu-svg-tolist"></div>
              <p style={{ width: "100px" }}>Orders Execution</p>
            </div>
            <span className="menu-text">Orders Execution</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        {GetUser().customer_view === "TRUE" && <li
          className={`menu-item ${getMenuItemActive(pagesLinks.orderCustomerDetailsRootTitle, false)} ${getMenuItemActive(pagesLinks.viewAllTOsCustomerGrid, false)}`}
          aria-haspopup="true"
        >
          <NavLink
            className={"menu-link " + (checkIsActive(location, pagesLinks.orderCustomerDetailsRootTitle) ? "active" : "")}
            to={pagesLinks.viewAllTOsCustomerGrid}
            onClick={() => { props.setNavigatedMenu("TOC List"); }}>
            <div className="menu-icon-container">
              <div className="menu-icon menu-svg-tocustomerlist"></div>
              <p style={{ width: "100px" }}>Orders Customer</p>
            </div>
            <span className="menu-text">Orders Customer</span>
          </NavLink>
        </li>}
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive(pagesLinks.tripDetailsRootTitle, false)}`}
          aria-haspopup="true"
        >
          <NavLink
            className={"menu-link " + (checkIsActive(location, pagesLinks.tripDetailsRootTitle) ? "active" : "")}
            to={pagesLinks.viewAllOngoingTripsGrid}
            onClick={() => { props.setNavigatedMenu("Trips List"); }}>
            <div className="menu-icon-container">
              <div className="menu-icon menu-svg-trips-list"></div>
              <p>Trips</p>
            </div>
            <span className="menu-text">Trips</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive(pagesLinks.salesOrderDetailsRootTitle, false)} ${getMenuItemActive(pagesLinks.viewAllSalesOrdersGrid, false)}`}
          aria-haspopup="true"
        >
          <NavLink
            className={"menu-link " + (checkIsActive(location, pagesLinks.salesOrderDetailsRootTitle) ? "active" : "")}
            to={pagesLinks.viewAllSalesOrdersGrid} onClick={() => { props.setNavigatedMenu("SO List"); }}>
            <div className="menu-icon-container">
              <div className="menu-icon menu-svg-solist"></div>
              <p>Sales Orders</p>
            </div>
            <span className="menu-text">Sales Orders</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive(pagesLinks.salesOrderDetailsRootTitle, false)} ${getMenuItemActive(pagesLinks.viewAllSalesOrdersGrid, false)}`}
          aria-haspopup="true"
        >
          <NavLink
            className={"menu-link " + (checkIsActive(location, pagesLinks.salesOrderDetailsRootTitle) ? "active" : "")}
            to={pagesLinks.viewAllOperationGrid} onClick={() => { props.setNavigatedMenu("Operation List"); }}>
            <div className="menu-icon-container">
              <div className="menu-icon menu-svg-solist"></div>
              <p>Operation</p>
            </div>
            <span className="menu-text">Operation</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
       {/*  <li
          className={`menu-item menu-item-submenu ${isBookingSubpage() ? "menu-item-open" : ""}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className={`menu-link menu-toggle ${isBookingSubpage() ? "active" : ""}`} to="/listpage/booking">
            <div className="menu-icon-container">
              <div className="menu-icon menu-svg-solist"></div>
              <p>Booking</p>
            </div>
            <span className="menu-text">Booking</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav" >
              <li className="menu-item  menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">Booking</span>
                </span>
              </li>

              <li
                className={`menu-item menu-item-submenu`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to={pagesLinks.viewAllBookingReservationGrid} onClick={() => { props.setNavigatedMenu("Activity reservation"); }}>
                  <span className="menu-text">Reservation</span>
                </NavLink>
              </li>
              <li
                className={`menu-item menu-item-submenu`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/listpage/booking-transport-order-execution" onClick={() => { props.setNavigatedMenu("TO Execution"); }}>
                  <span className="menu-text">TO Execution</span>
                </NavLink>
              </li>
              <li
                className={`menu-item menu-item-submenu`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to={pagesLinks.viewAllBookingReservationTripsGrid} onClick={() => { props.setNavigatedMenu("Trip"); }}>
                  <span className="menu-text">Trip</span>
                </NavLink>
              </li>

            </ul>
          </div>
        </li> */}
        {/*end::1 Level*/}

        {/* Components */}
        {/* begin::section */}
        {/* <li className="menu-section ">
            <h4 className="menu-text">Components</h4>
            <i className="menu-icon flaticon-more-v2"></i>
          </li> */}
        {/* end:: section */}
  {/*begin::1 Level*/}
  <li
          className={`menu-item ${getMenuItemActive("/favourites", false)}`}
          aria-haspopup="true"
        >
          {props.bookmark && <Timer
            initialTime={9999}
            direction="backward"
            startImmediately={true}
            checkpoints={[
              {
                time: 0,
                callback: disableNotification,
              },
            ]}>
          </Timer>}
          <NavLink className="menu-link" to={pagesLinks.favourites} onClick={() => { props.setNavigatedMenu("Bookmarks"); }}>
            <Badge badgeContent={props.bookmark ? "+1" : 0} className="favourites-badge menu-icon-container">
              <div className="menu-icon menu-svg-bookmarks"></div>
              <p>Bookmarks</p>
            </Badge>
            <span className="menu-text">Bookmarks</span>
          </NavLink>

        </li>
        {/*end::1 Level*/}
        {/* Analytics */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/analytics", true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/analytics">
            <div className="menu-icon-container">
              <div className="menu-icon menu-svg-analytics"></div>
              <p>Analytics</p>
            </div>
            <span className="menu-text">Analytics</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav" style={{ marginBottom: "45%" }}>
              <li className="menu-item  menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">Analytics</span>
                </span>
              </li>

              {/* Lista link da mostrare nel sottomenu di Analytics */}
              {/*begin::2 Level*/}
              {linksList}
              {/*end::2 Level*/}

              {/* Report Order Variance */}
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-submenu`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to={pagesLinks.orderVariance} onClick={() => { props.setNavigatedMenu("Order Variance"); }}>
                  <span className="menu-text">Order Variance</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}

              {/* Event Monitoring */}
              {/*begin::2 Level*/}
              {hasClaim(UOM_ROLE_EVENT_MONITORING, UOM_EVENT_MONITORING_VALUE) &&
                <li
                  className={`menu-item menu-item-submenu`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link menu-toggle" to={pagesLinks.eventMonitoring} onClick={() => { props.setNavigatedMenu("Event Monitoring"); }}>
                    <span className="menu-text">Event Monitoring</span>
                  </NavLink>
                </li>
              }
              {/*end::2 Level*/}

              {/* Viste personalizzate */}
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-submenu`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/analytics/custom-views" onClick={() => { props.setNavigatedMenu("Custom Views"); }}>
                  <span className="menu-text">Custom Views</span>
                </NavLink>
              </li>
              {/*end::2 Level*/}

            </ul>
          </div>
        </li>
        {/*end::1 Level*/}

        {/* Settings */}
        {/*begin::1 Level*/}
        {hasClaim(UOM_ROLE, UOM_ROLE_ADMIN) &&
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/settings", true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/settings" onClick={() => { props.setNavigatedMenu("Configuration"); }}>
              <div className="menu-icon-container">
                <div className="menu-icon menu-svg-settings"></div>
                <p>Settings</p>
              </div>
              <span className="menu-text">Settings</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav" style={{ marginBottom: "75%" }}>
                <li className="menu-item  menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">Settings</span>
                  </span>
                </li>

                {/*begin::2 Level*/}
                <li
                  className={`menu-item menu-item-submenu`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link menu-toggle" to={pagesLinks.settings + "/customers"}>
                    <span className="menu-text">Customers</span>
                  </NavLink>
                </li>
                {/*end::2 Level*/}

                {/*begin::2 Level*/}
                <li
                  className={`menu-item menu-item-submenu`}
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                >
                  <NavLink className="menu-link menu-toggle" to={pagesLinks.settings + "/custom-views"}>
                    <span className="menu-text">Custom Views</span>
                  </NavLink>
                </li>
                {/*end::2 Level*/}

              </ul>
            </div>
          </li>
        }
        {/*end::1 Level*/}

      
      </ul>

      {/* end::Menu Nav */}
    </>
  );
};

const mapStateToProps = function (state) {
  return {
    bookmark: state.bookmark.newBookmark
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setNewBookmark: (value) => {
      dispatch(setNewBookmark(value));
    },
    setNavigatedMenu: (menu) => {
      dispatch(ordersNavigationActions.setNavigatedMenu(menu));
    }
  };
};

export const AsideMenuList = connect(mapStateToProps, mapDispatchToProps)(AsideMenuListContainer);